<template>
    <div class="card shadow px-3 pt-3 mb-3 bg-white rounded">
        <div class="container">
            <!--Section: Content-->
            <section class="text-center">
                <div class="row d-flex justify-content-center">
                    <div class="h4 col-auto mb-5"><strong>Notifications des alertes</strong></div>
                    <div class="col-auto">
                        <RouterLink :to="'/contacts/'">
                            <ButtonDisplay type="add" text="Contacts" />
                        </RouterLink>
                    </div>
                </div>

                <div class="row d-flex justify-content-around gx-lg-5">

                    <div class="col-lg-3 col-md-6 mb-4">
                        <div class="card shadow">

                            <div class="card-header bg-body-tertiary py-3">
                                <h5 class="mb-2"><strong>Alertes techniques</strong></h5>
                            </div>

                            <div class="card-body">
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item" v-for="alert in alertesTech" :key="alert.name">
                                        {{ alert.name }}
                                        <div v-if="!alert.balises.includes(balise.type)"
                                            class="text-secondary small fst-italic">Non compatible</div>
                                    </li>
                                    <li class="list-group-item">
                                        <ContactDisplay v-for="contact in contactsTechniques" :key="contact.id"
                                            :contact="contact" @remove="(id) => removeContact(2, id)">
                                        </ContactDisplay>
                                    </li>
                                </ul>
                            </div>

                            <div class="card-footer bg-body-tertiary py-3">
                                <select v-if="contacts?.length"
                                v-model="contactToAdd"
                                @change="addContact(2)" class="form-select" aria-label="Default select example">
                                    <template v-for="contact in contacts"
                                    :key="contact.id">
                                    <option v-if="!(contact.type == 'MOBILE' && balise.commercialPackageId == 1)"
                                    :value="contact.id">{{ contact.name + " " + contact.contact }}</option>
                                    </template>
                                </select>
                                <div v-else class="small">
                                    Aucun contact disponible<br>
                                    <RouterLink :to="'/contacts/'">
                                        Créer des contacts
                                    </RouterLink>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="col-lg-3 col-md-6 mb-4">
                        <div class="card shadow">

                            <div class="card-header bg-body-tertiary py-3" :class="{'locked-section': balise.commercialPackage?.id == 1 }">
                                <h5 class="mb-2"><strong>Alertes sécurité</strong></h5>
                            </div>

                            <div class="card-body" :class="{'locked-section': balise.commercialPackage?.id == 1 }">
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item" v-for="alert in alertesSecu" :key="alert.name">
                                        {{ alert.name }}
                                        <div v-if="!alert.balises.includes(balise.type) || (alert.plusAContact && !balise.plusAContact)"
                                            class="text-secondary small fst-italic">Non compatible</div>
                                    </li>
                                    <li class="list-group-item">
                                        <ContactDisplay v-for="contact in contactsSecurite" :key="contact.id"
                                            :contact="contact" @remove="(id) => removeContact(1, id)">
                                        </ContactDisplay>
                                    </li>
                                </ul>
                            </div>
                            <div v-if="this.balise.commercialPackage?.id != 1" class="card-footer bg-body-tertiary py-3">
                                <select v-if="contacts?.length"
                                v-model="contactToAdd"
                                @change="addContact(1)" class="form-select" aria-label="Default select example">
                                    <option v-for="contact in contacts"
                                    :key="contact.id"
                                    :value="contact.id">{{ contact.name + " " + contact.contact }}</option>
                                </select>
                                <div v-else class="small">
                                    Aucun contact disponible<br>
                                    <RouterLink :to="'/contacts/'">
                                        Créer des contacts
                                    </RouterLink>
                                </div>
                            </div>
                            <div v-else class="card-footer bg-body-tertiary py-3 small">
                                Cette option n'est pas incluse dans votre offre.<br>
                                Disponible dans <span class="text-success fw-bold text-decoration-underline">Geo
                                    Plus</span> & <span class="text-success fw-bold text-decoration-underline">Geo
                                    Full</span>
                            </div>
                        </div>
                    </div>


                    <div v-if="balise.digitalIOs?.length" class="col-lg-3 col-md-6 mb-4">
                        <div class="card shadow">
                            <div class="card-header bg-body-tertiary py-3" :class="{'locked-section': balise.commercialPackage?.id == 1 }">
                                <h5 class="mb-2"><strong>Alertes personnalisées</strong></h5>
                            </div>
                            <div class="card-body" :class="{'locked-section': balise.commercialPackage?.id == 1 }">
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item">Déclenchement d'alarme</li>
                                    <li class="list-group-item">
                                        <ContactDisplay v-for="contact in contactsPersonnalisee" 
                                        :key="contact.id"
                                        :contact="contact"
                                        @remove="(id) => removeContact(5, id)">
                                        </ContactDisplay>
                                    </li>
                                </ul>
                            </div>
                            <div v-if="this.balise.commercialPackage?.id != 1" class="card-footer bg-body-tertiary py-3">
                                <select v-if="contacts?.length"
                                v-model="contactToAdd"
                                @change="addContact(5)" class="form-select" aria-label="Default select example">
                                    <option v-for="contact in contacts"
                                    :key="contact.id"
                                    :value="contact.id">{{ contact.name + " " + contact.contact }}</option>
                                </select>
                                <div v-else class="small">
                                    Aucun contact disponible<br>
                                    <RouterLink :to="'/contacts/'">
                                        Créer des contacts
                                    </RouterLink>
                                </div>
                            </div>
                            <div v-else class="card-footer bg-body-tertiary py-3 small">
                                Cette option n'est pas incluse dans votre offre.<br>
                                Disponible dans <span class="text-success fw-bold text-decoration-underline">Geo
                                    Plus</span> & <span class="text-success fw-bold text-decoration-underline">Geo
                                    Full</span>
                            </div>
                        </div>
                    </div>


                    <div class="col-lg-3 col-md-6 mb-4">
                        <div class="card shadow">
                            <div class="card-header bg-body-tertiary py-3 locked-section">
                                <h5 class="mb-2"><strong>Alertes +</strong></h5>
                            </div>
                            <div class="card-body locked-section">
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item">USB connecté</li>
                                    <li class="list-group-item">Brouillage</li>
                                    <li class="list-group-item">Porte ouverte</li>
                                </ul>
                            </div>
                            <div class="card-footer bg-body-tertiary py-3 small">
                                Cette option n'est pas incluse dans votre offre.<br>
                                Disponible dans <span class="text-success fw-bold text-decoration-underline">Geo
                                    Full</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="m-2 small">({{ 'Textos restants : ' + this.sms }})</div>
            </section>
        </div>
    </div>
</template>



<script>
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'
import NotificationService from '@/services/notification.service.js'
import ContactService from '@/services/contact.service.js'
import ClientService from '@/services/client.service.js'
import ContactDisplay from '../Components/ContactDisplay.vue'
import FormatHelper from '@/helpers/format.helper.js'

export default {
    props: ['balise'],
    components: {
        ButtonDisplay,
        ContactDisplay
    },
    data() {
        return {
            contactsTechniques: null,
            contactsSecurite: null,
            contactsPersonnalisee: null,
            contactsConduite: null,
            contactsAlarmesPlus: null,
            contacts: null,
            sms: null,
            alertesTech: [
                {
                    balises: ["TLW2", "FMC003", "FMB920", "FMC920", "FMC130", 'FMC225', 'FMC230', 'FMC800'],
                    name: 'Défaut alimentation'
                },
                {
                    balises: ["TLW2", "FMC003", "FMB920", "FMC920", "KNIGHTX100", "FMC130", 'FMC225', 'FMC230', 'FMC800'],
                    name: 'Défaut batterie'
                }
            ],
            alertesSecu: [
                {
                    balises: ["TLW2", "FMC003", "FMB920", "FMC920", "FMC130", 'FMC225', 'FMC230', 'FMC800'],
                    name: 'Remorquage',
                    plusAContact: true
                },
                {
                    balises: ["TLW2", "FMC003", "FMB920", "FMC920", "KNIGHTX100", "FMC130", 'FMC225', 'FMC230', 'FMC800'],
                    name: 'Périmètre de stationnement'
                },
                {
                    balises: ["KNIGHTX100"],
                    name: 'Bouton SOS'
                }
            ],
        };
    },
    mounted() {
        this.refreshData();
    },
    methods: {
        refreshData() {
            NotificationService.getProfileContacts(this.balise.id, 2)
                .then(response => {
                    this.contactsTechniques = FormatHelper.contactsResponseFormat(response.data);
                })
                .catch(e => {
                    console.log(e);
                });

            NotificationService.getProfileContacts(this.balise.id, 1)
                .then(response => {
                    this.contactsSecurite = FormatHelper.contactsResponseFormat(response.data);
                })
                .catch(e => {
                    console.log(e);
                });

            NotificationService.getProfileContacts(this.balise.id, 5)
                .then(response => {
                    this.contactsPersonnalisee = FormatHelper.contactsResponseFormat(response.data);
                })
                .catch(e => {
                    console.log(e);
                });

            ContactService.getList()
                .then(response => {
                    this.contacts = FormatHelper.contactsResponseFormat(response.data);
                })
                .catch(e => {
                    console.log(e);
                });

            ClientService.getClient()
                .then(response => {
                    this.sms = response.data.sms;
                })
                .catch(e => {
                    console.log(e);
                });

        },
        addContact(profileId) {
            NotificationService.addContact(this.balise.id, profileId, this.contactToAdd)
                .then(() => {
                    this.refreshData();
                    this.contactToAdd = null;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        removeContact(profileId, contactId) {
            NotificationService.removeContact(this.balise.id, profileId, contactId)
                .then(() => {
                    this.refreshData();
                })
                .catch(e => {
                    console.log(e);
                });
        },
    }
}

</script>

<style scoped>
.locked-section {
    position: relative;
    filter: grayscale(0.8);
    opacity: 0.4;
    pointer-events: none;
}

.locked-section::after {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.35);
    border-radius: .5rem;
}
</style>